__webpack_require__.p = "https://challengemachinery.com/";